import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private readonly baseUrl: string;
  private readonly supportedLangs = ['en', 'fr', 'de', 'pt', 'es'];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {
    const hostname = this.document.location.hostname;
    this.baseUrl = hostname.includes('staging')
      ? 'https://staging.ggboost.com'
      : 'https://ggboost.com';
  }

  setCanonical(customUrl?: string): void {
    const url = customUrl || this.router.url;
    const cleanUrl = this.stripQueryParams(url);

    let link = this.document.head.querySelector("link[rel='canonical']") as HTMLLinkElement;

    if (!link) {
      link = this.document.createElement('link');
      link.rel = 'canonical';
      this.document.head.appendChild(link);
    }

    link.href = this.baseUrl + cleanUrl;
  }

  removeCanonical(): void {
    const link = this.document.head.querySelector("link[rel='canonical']");
    if (link) {
      this.document.head.removeChild(link);
    }
  }

  setHreflang(path: string): void {
    this.removeHreflang();

    const cleanPath = this.stripQueryParams(path);

    this.supportedLangs.forEach(lang => {
      const link = this.document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;

      if (lang === 'en') {
        link.href = this.baseUrl + cleanPath;
      } else {
        link.href = this.baseUrl + '/' + lang + cleanPath;
      }

      this.document.head.appendChild(link);
    });

    const defaultLink = this.document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = this.baseUrl + cleanPath;
    this.document.head.appendChild(defaultLink);
  }

  removeHreflang(): void {
    const links = this.document.head.querySelectorAll("link[rel='alternate'][hreflang]");
    links.forEach(link => this.document.head.removeChild(link));
  }

  setCanonicalAndHreflang(currentLang = 'en', customPath?: string): void {
    const path = customPath || this.router.url;
    const basePath = this.getBasePath(path, currentLang);

    this.setCanonical(path);
    // this.setHreflang(basePath);
  }

  private stripQueryParams(url: string): string {
    const clean = url.split('?')[0].split('#')[0];
    return clean.length > 1 ? clean.replace(/\/$/, '') : clean;
  }

  private getBasePath(url: string, currentLang: string): string {
    const cleanUrl = this.stripQueryParams(url);

    if (currentLang !== 'en' && cleanUrl.startsWith('/' + currentLang)) {
      return cleanUrl.substring(currentLang.length + 1) || '/';
    }

    return cleanUrl;
  }
}
